import { render, staticRenderFns } from "./editBurial.vue?vue&type=template&id=3e9181b8"
import script from "./editBurial.vue?vue&type=script&lang=js"
export * from "./editBurial.vue?vue&type=script&lang=js"
import style0 from "./editBurial.vue?vue&type=style&index=0&id=3e9181b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports